export class ContactFunction {
    ID: number;
    Code: string;
    Name: string;
    Inactive?: boolean;
    FullName?: string;
}

export default ContactFunction;